<script setup lang="ts">
import ClarityBossLogo from '@/components/ClarityBossLogo.vue'
import { Button } from '@/components/ui/button'
import { LogInIcon } from '@lucide/vue'
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<template>
  <div class="flex fixed z-40 top-0 left-0 h-12 w-full bg-background-surface text-2xl shadow-sm print:hidden">
    <nav class="max-w-400 mx-auto px-2 flex w-full items-center gap-2 md:gap-3">
      <div class="flex justify-items-end gap-2 sm:gap-5 md:gap-7 flex-1 items-baseline">
        <RouterLink to="/" class="hidden md:block">
          <ClarityBossLogo size="sm" />
        </RouterLink>
        <RouterLink to="/" class="block md:hidden bg-main lowercase rounded-lg px-1 shadow-xs shadow-black/25">
          <span class="text-main-foreground font-black">C</span>
          <span class="text-boss font-base">B</span>
        </RouterLink>
        <RouterLink class="nav-link pb-1 text-lg" to="/protips">
          <span class="font-black">pro</span><span class="font-light">tips</span>
        </RouterLink>
        <RouterLink class="nav-link pb-1 text-lg" to="/integrations">
          <span>integrations</span>
        </RouterLink>
        <RouterLink class="nav-link pb-1 text-lg" to="/pricing">
          <span>pricing</span>
        </RouterLink>
      </div>
      <RouterLink v-if="route.name !== 'signin'" to="/signin">
        <Button variant="ghost" size="sm"><LogInIcon /> Sign In</Button>
      </RouterLink>
      <RouterLink class="hidden md:block" to="/demo">
        <Button size="sm"> Request a Demo</Button>
      </RouterLink>
    </nav>
  </div>
</template>

<style>
nav .nav-link {
  position: relative;
}

nav .nav-link::before,
nav .nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 100%;
  height: 4px;
  transform: translateX(-50%) scaleX(0);
  transform-origin: 50% 50%;
  opacity: 0;
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

nav .nav-link::before {
  background-color: var(--main);
}

nav .nav-link::after {
  background-color: var(--foreground);
}

nav .nav-link:not(.router-link-active):hover::after {
  transform: translateX(-50%) scaleX(1);
  opacity: 1;
}

nav .router-link-active::before {
  transform: translateX(-50%) scaleX(1);
  opacity: 1;
}

nav .router-link-active::after {
  transform: translateX(-50%) scaleX(0);
  opacity: 0;
}
</style>
